var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elise-statistics"},[_c('h3',[_vm._v("Elise Pomeroy (Estatísticas)")]),_c('br'),_c('StatisticsTable',{attrs:{"items":_vm.statistics}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }